export default {
  UPDATE_USERINFO (state, userInfo) {
    state.currentUserInfo = userInfo;
  },
};
